<template>
  <button type="button" :disabled="disabled" @click="onClick">
    {{ btnText }}
  </button>
</template>

<script>
import { sendCode } from "@/api";

export default {
  name: "VerifyCodeSender",
  props: {
    roleId: String,
    pattern: RegExp
  },
  data() {
    return {
      countdown: 0, // 倒计时状态
      timer: null, // 倒计时延迟器
      btnText: "",
      defaultText: "获取验证码"
    };
  },
  computed: {
    disabled() {
      const { countdown, roleId, pattern } = this;
      if (countdown === 0) {
        if (!roleId) return true;
        return !pattern.test(roleId);
      }
      return true;
    }
  },
  watch: {
    roleId: {
      handler: function() {
        if (this.countdown > 0) {
          this.countdown = 0;
        }
      }
    }
  },
  mounted() {
    this.btnText = this.defaultText;
  },
  methods: {
    async onClick() {
      try {
        const { code, msg, data } = await sendCode({ role_id: this.roleId });
        if (code === 0 && msg) this.$toast(msg);
        if (data && data.limit) {
          this.countdown = data.limit;
          this.autoplay();
        }
      } catch (err) {
        //
      }
    },
    // 发送倒计时
    autoplay() {
      const { defaultText } = this;
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
            if (this.countdown == 0) {
              this.btnText = defaultText;
            } else {
              this.btnText = `${this.countdown}秒`;
            }
          } else {
            clearInterval(this.timer);
            this.btnText = defaultText;
            this.timer = null;
          }
        }, 1000);
      }
    }
  }
};
</script>
